import * as Yup from "yup";

export const SaleStatusValidationSchema = Yup.object().shape({
  name: Yup.string().max(50).required("Required!"),
  archetype: Yup.string().required("Required!"),
  saleType: Yup.string().nullable(),
});
